export const BOXICONS = [
  'bx bx-shape-polygon',
  'bx bx-donate-blood',
  'bx bx-donate-heart',
  'bx bx-door-open',
  'bx bx-credit-card-front',
  'bx bx-cookie',
  'bx bx-comment-detail',
  'bx bx-comment-add',
  'bx bx-comment-minus',
  'bx bx-comment-edit',
  'bx bx-comment-x',
  'bx bx-comment-error',
  'bx bx-comment-check',
  'bx bx-message-square-detail',
  'bx bx-message-square-add',
  'bx bx-message-square-edit',
  'bx bx-message-square-minus',
  'bx bx-message-square-x',
  'bx bx-message-square-error',
  'bx bx-message-square-check',
  'bx bx-message-detail',
  'bx bx-message-add',
  'bx bx-message-edit',
  'bx bx-message-minus',
  'bx bx-message-x',
  'bx bx-message-error',
  'bx bx-message-check',
  'bx bx-message-rounded-detail',
  'bx bx-message-rounded-add',
  'bx bx-message-rounded-edit',
  'bx bx-message-rounded-minus',
  'bx bx-message-rounded-x',
  'bx bx-message-rounded-error',
  'bx bx-message-rounded-check',
  'bx bx-message-alt-detail',
  'bx bx-message-alt-edit',
  'bx bx-message-alt-minus',
  'bx bx-message-alt-x',
  'bx bx-message-alt-error',
  'bx bx-message-alt-check',
  'bx bx-message-alt-add',
  'bx bx-envelope-open',
  'bx bx-home-smile',
  'bx bx-refresh',
  'bx bx-meteor',
  'bx bx-outline',
  'bx bx-trim',
  'bx bx-merge',
  'bx bx-minus-back',
  'bx bx-exclude',
  'bx bx-intersect',
  'bx bx-minus-front',
  'bx bx-unite',
  'bx bx-coin-stack',
  'bx bx-coin',
  'bx bx-church',
  'bx bx-chevron-right-square',
  'bx bx-chevron-left-square',
  'bx bx-chevron-up-square',
  'bx bx-chevron-down-square',
  'bx bx-chevron-right-circle',
  'bx bx-chevron-left-circle',
  'bx bx-chevron-up-circle',
  'bx bx-chevron-down-circle',
  'bx bx-line-chart-down',
  'bx bx-shield-x',
  'bx bx-caret-down-square',
  'bx bx-caret-left-square',
  'bx bx-caret-up-square',
  'bx bx-caret-right-square',
  'bx bx-caret-down-circle',
  'bx bx-caret-up-circle',
  'bx bx-caret-left-circle',
  'bx bx-caret-right-circle',
  'bx bx-camera-movie',
  'bx bx-camera-home',
  'bx bx-calendar-star',
  'bx bx-calendar-exclamation',
  'bx bx-vector',
  'bx bx-network-chart',
  'bx bx-chair',
  'bx bx-cctv',
  'bx bx-drink',
  'bx bx-eraser',
  'bx bx-capsule',
  'bx bx-color-fill',
  'bx bx-vial',
  'bx bx-wine',
  'bx bx-calendar-heart',
  'bx bx-window-alt',
  'bx bx-braille',
  'bx bx-border-outer',
  'bx bx-brain',
  'bx bx-bracket',
  'bx bx-book-add',
  'bx bx-book-heart',
  'bx bx-book-alt',
  'bx bx-bong',
  'bx bx-bone',
  'bx bx-blanket',
  'bx bx-barcode-reader',
  'bx bx-task-x',
  'bx bx-medal',
  'bx bx-alarm-exclamation',
  'bx bx-alarm-snooze',
  'bx bx-abacus',
  'bx bx-game',
  'bx bx-tachometer',
  'bx bx-sticker',
  'bx bx-spray-can',
  'bx bx-webcam',
  'bx bx-dice-6',
  'bx bx-dice-5',
  'bx bx-dice-4',
  'bx bx-dice-3',
  'bx bx-dice-2',
  'bx bx-dice-1',
  'bx bx-border-inner',
  'bx bx-border-none',
  'bx bx-glasses-alt',
  'bx bx-glasses',
  'bx bx-calendar-week',
  'bx bx-scan',
  'bx bx-book-reader',
  'bx bx-arrow-to-bottom',
  'bx bx-arrow-to-top',
  'bx bx-arrow-to-left',
  'bx bx-arrow-to-right',
  'bx bx-arrow-from-right',
  'bx bx-arrow-from-left',
  'bx bx-arrow-from-bottom',
  'bx bx-arrow-from-top',
  'bx bx-current-location',
  'bx bx-been-here',
  'bx bx-low-vision',
  'bx bx-mask',
  'bx bx-wifi-0',
  'bx bx-wifi-1',
  'bx bx-wifi-2',
  'bx bx-traffic-cone',
  'bx bx-recycle',
  'bx bx-layer-minus',
  'bx bx-layer-plus',
  'bx bx-info-square',
  'bx bx-home-heart',
  'bx bx-heart-square',
  'bx bx-heart-circle',
  'bx bx-microchip',
  'bx bx-pointer',
  'bx bx-coffee-togo',
  'bx bx-calendar-edit',
  'bx bx-cabinet',
  'bx bx-bus-school',
  'bx bx-bomb',
  'bx bx-bible',
  'bx bx-beer',
  'bx bx-baseball',
  'bx bx-atom',
  'bx bx-arch',
  'bx bx-location-plus',
  'bx bx-shape-triangle',
  'bx bx-shape-square',
  'bx bx-video-recording',
  'bx bx-notepad',
  'bx bx-bug-alt',
  'bx bx-mouse-alt',
  'bx bx-edit-alt',
  'bx bx-chat',
  'bx bx-book-content',
  'bx bx-message-square-dots',
  'bx bx-message-square',
  'bx bx-slideshow',
  'bx bx-wallet-alt',
  'bx bx-memory-card',
  'bx bx-message-rounded-dots',
  'bx bx-message-dots',
  'bx bx-bar-chart-alt-2',
  'bx bx-store-alt',
  'bx bx-buildings',
  'bx bx-home-circle',
  'bx bx-money',
  'bx bx-walk',
  'bx bx-repeat',
  'bx bx-font-family',
  'bx bx-joystick-button',
  'bx bx-paint',
  'bx bx-unlink',
  'bx bx-brush',
  'bx bx-rotate-left',
  'bx bx-badge-check',
  'bx bx-show-alt',
  'bx bx-caret-down',
  'bx bx-caret-right',
  'bx bx-caret-up',
  'bx bx-caret-left',
  'bx bx-calendar-event',
  'bx bx-magnet',
  'bx bx-rewind-circle',
  'bx bx-card',
  'bx bx-help-circle',
  'bx bx-test-tube',
  'bx bx-note',
  'bx bx-sort-down',
  'bx bx-sort-up',
  'bx bx-id-card',
  'bx bx-badge',
  'bx bx-grid-small',
  'bx bx-grid-vertical',
  'bx bx-grid-horizontal',
  'bx bx-move-vertical',
  'bx bx-move-horizontal',
  'bx bx-stats',
  'bx bx-equalizer',
  'bx bx-disc',
  'bx bx-analyse',
  'bx bx-search-alt',
  'bx bx-dollar-circle',
  'bx bx-football',
  'bx bx-ball',
  'bx bx-circle',
  'bx bx-transfer',
  'bx bx-fingerprint',
  'bx bx-font-color',
  'bx bx-highlight',
  'bx bx-file-blank',
  'bx bx-strikethrough',
  'bx bx-photo-album',
  'bx bx-code-block',
  'bx bx-font-size',
  'bx bx-handicap',
  'bx bx-dialpad',
  'bx bx-wind',
  'bx bx-water',
  'bx bx-swim',
  'bx bx-restaurant',
  'bx bx-box',
  'bx bx-menu-alt-right',
  'bx bx-menu-alt-left',
  'bx bx-video-plus',
  'bx bx-list-ol',
  'bx bx-planet',
  'bx bx-hotel',
  'bx bx-movie',
  'bx bx-taxi',
  'bx bx-train',
  'bx bx-bath',
  'bx bx-bed',
  'bx bx-area',
  'bx bx-bot',
  'bx bx-dumbbell',
  'bx bx-check-double',
  'bx bx-bus',
  'bx bx-check-circle',
  'bx bx-rocket',
  'bx bx-certification',
  'bx bx-slider-alt',
  'bx bx-sad',
  'bx bx-meh',
  'bx bx-happy',
  'bx bx-cart-alt',
  'bx bx-car',
  'bx bx-loader-alt',
  'bx bx-loader-circle',
  'bx bx-wrench',
  'bx bx-alarm-off',
  'bx bx-layout',
  'bx bx-dock-left',
  'bx bx-dock-top',
  'bx bx-dock-right',
  'bx bx-dock-bottom',
  'bx bx-world',
  'bx bx-selection',
  'bx bx-paper-plane',
  'bx bx-slider',
  'bx bx-loader',
  'bx bx-chalkboard',
  'bx bx-trash-alt',
  'bx bx-grid-alt',
  'bx bx-command',
  'bx bx-window-close',
  'bx bx-notification-off',
  'bx bx-plug',
  'bx bx-infinite',
  'bx bx-carousel',
  'bx bx-hourglass',
  'bx bx-briefcase-alt',
  'bx bx-wallet',
  'bx bx-station',
  'bx bx-collection',
  'bx bx-tv',
  'bx bx-closet',
  'bx bx-paperclip',
  'bx bx-expand',
  'bx bx-pen',
  'bx bx-purchase-tag',
  'bx bx-images',
  'bx bx-pie-chart-alt',
  'bx bx-news',
  'bx bx-downvote',
  'bx bx-upvote',
  'bx bx-globe-alt',
  'bx bx-store',
  'bx bx-hdd',
  'bx bx-skip-previous-circle',
  'bx bx-skip-next-circle',
  'bx bx-chip',
  'bx bx-cast',
  'bx bx-body',
  'bx bx-phone-outgoing',
  'bx bx-phone-incoming',
  'bx bx-collapse',
  'bx bx-rename',
  'bx bx-rotate-right',
  'bx bx-horizontal-center',
  'bx bx-ruler',
  'bx bx-import',
  'bx bx-calendar-alt',
  'bx bx-battery',
  'bx bx-server',
  'bx bx-task',
  'bx bx-folder-open',
  'bx bx-film',
  'bx bx-aperture',
  'bx bx-phone-call',
  'bx bx-up-arrow',
  'bx bx-undo',
  'bx bx-timer',
  'bx bx-support',
  'bx bx-subdirectory-right',
  'bx bx-subdirectory-left',
  'bx bx-right-arrow',
  'bx bx-revision',
  'bx bx-repost',
  'bx bx-reply',
  'bx bx-reply-all',
  'bx bx-redo',
  'bx bx-radar',
  'bx bx-poll',
  'bx bx-list-check',
  'bx bx-like',
  'bx bx-left-arrow',
  'bx bx-joystick-alt',
  'bx bx-history',
  'bx bx-flag',
  'bx bx-first-aid',
  'bx bx-export',
  'bx bx-down-arrow',
  'bx bx-dislike',
  'bx bx-crown',
  'bx bx-barcode',
  'bx bx-user',
  'bx bx-user-x',
  'bx bx-user-plus',
  'bx bx-user-minus',
  'bx bx-user-circle',
  'bx bx-user-check',
  'bx bx-underline',
  'bx bx-trophy',
  'bx bx-trash',
  'bx bx-text',
  'bx bx-sun',
  'bx bx-star',
  'bx bx-sort',
  'bx bx-shuffle',
  'bx bx-shopping-bag',
  'bx bx-shield',
  'bx bx-shield-alt',
  'bx bx-share',
  'bx bx-share-alt',
  'bx bx-select-multiple',
  'bx bx-screenshot',
  'bx bx-save',
  'bx bx-pulse',
  'bx bx-power-off',
  'bx bx-plus',
  'bx bx-pin',
  'bx bx-pencil',
  'bx bx-paste',
  'bx bx-paragraph',
  'bx bx-package',
  'bx bx-notification',
  'bx bx-shield-quarter',
  'bx bx-move',
  'bx bx-mouse',
  'bx bx-minus',
  'bx bx-microphone-off',
  'bx bx-log-out',
  'bx bx-log-in',
  'bx bx-link-external',
  'bx bx-joystick',
  'bx bx-italic',
  'bx bx-home-alt',
  'bx bx-heading',
  'bx bx-hash',
  'bx bx-group',
  'bx bx-git-repo-forked',
  'bx bx-git-pull-request',
  'bx bx-git-merge',
  'bx bx-git-compare',
  'bx bx-git-commit',
  'bx bx-git-branch',
  'bx bx-font',
  'bx bx-filter',
  'bx bx-file',
  'bx bx-edit',
  'bx bx-diamond',
  'bx bx-detail',
  'bx bx-cut',
  'bx bx-cube',
  'bx bx-crop',
  'bx bx-credit-card',
  'bx bx-columns',
  'bx bx-cog',
  'bx bx-cloud-snow',
  'bx bx-cloud-rain',
  'bx bx-cloud-lightning',
  'bx bx-cloud-light-rain',
  'bx bx-cloud-drizzle',
  'bx bx-check',
  'bx bx-cart',
  'bx bx-calculator',
  'bx bx-bold',
  'bx bx-award',
  'bx bx-anchor',
  'bx bx-album',
  'bx bx-adjust',
  'bx bx-x',
  'bx bx-table',
  'bx bx-duplicate',
  'bx bx-windows',
  'bx bx-window',
  'bx bx-window-open',
  'bx bx-wifi',
  'bx bx-voicemail',
  'bx bx-video-off',
  'bx bx-usb',
  'bx bx-upload',
  'bx bx-alarm',
  'bx bx-tennis-ball',
  'bx bx-target-lock',
  'bx bx-tag',
  'bx bx-tab',
  'bx bx-spreadsheet',
  'bx bx-sitemap',
  'bx bx-sidebar',
  'bx bx-send',
  'bx bx-pie-chart',
  'bx bx-phone',
  'bx bx-navigation',
  'bx bx-mobile',
  'bx bx-mobile-alt',
  'bx bx-message',
  'bx bx-message-rounded',
  'bx bx-map',
  'bx bx-map-alt',
  'bx bx-lock',
  'bx bx-lock-open',
  'bx bx-list-minus',
  'bx bx-list-ul',
  'bx bx-list-plus',
  'bx bx-link',
  'bx bx-link-alt',
  'bx bx-layer',
  'bx bx-laptop',
  'bx bx-home',
  'bx bx-heart',
  'bx bx-headphone',
  'bx bx-devices',
  'bx bx-globe',
  'bx bx-gift',
  'bx bx-envelope',
  'bx bx-download',
  'bx bx-dots-vertical',
  'bx bx-dots-vertical-rounded',
  'bx bx-dots-horizontal',
  'bx bx-dots-horizontal-rounded',
  'bx bx-dollar',
  'bx bx-directions',
  'bx bx-desktop',
  'bx bx-data',
  'bx bx-compass',
  'bx bx-crosshair',
  'bx bx-terminal',
  'bx bx-cloud',
  'bx bx-cloud-upload',
  'bx bx-cloud-download',
  'bx bx-chart',
  'bx bx-calendar',
  'bx bx-calendar-x',
  'bx bx-calendar-minus',
  'bx bx-calendar-check',
  'bx bx-calendar-plus',
  'bx bx-buoy',
  'bx bx-bulb',
  'bx bx-bluetooth',
  'bx bx-bug',
  'bx bx-building',
  'bx bx-broadcast',
  'bx bx-briefcase',
  'bx bx-bookmark-plus',
  'bx bx-bookmark-minus',
  'bx bx-book',
  'bx bx-book-bookmark',
  'bx bx-block',
  'bx bx-basketball',
  'bx bx-bar-chart',
  'bx bx-bar-chart-square',
  'bx bx-bar-chart-alt',
  'bx bx-at',
  'bx bx-archive',
  'bx bx-zoom-out',
  'bx bx-zoom-in',
  'bx bx-x-circle',
  'bx bx-volume',
  'bx bx-volume-mute',
  'bx bx-volume-low',
  'bx bx-volume-full',
  'bx bx-video',
  'bx bx-vertical-center',
  'bx bx-up-arrow-circle',
  'bx bx-trending-up',
  'bx bx-trending-down',
  'bx bx-toggle-right',
  'bx bx-toggle-left',
  'bx bx-time',
  'bx bx-sync',
  'bx bx-stopwatch',
  'bx bx-stop',
  'bx bx-stop-circle',
  'bx bx-skip-previous',
  'bx bx-skip-next',
  'bx bx-show',
  'bx bx-search',
  'bx bx-rss',
  'bx bx-right-top-arrow-circle',
  'bx bx-right-indent',
  'bx bx-right-down-arrow-circle',
  'bx bx-right-arrow-circle',
  'bx bx-reset',
  'bx bx-rewind',
  'bx bx-rectangle',
  'bx bx-radio-circle',
  'bx bx-radio-circle-marked',
  'bx bx-question-mark',
  'bx bx-plus-circle',
  'bx bx-play',
  'bx bx-play-circle',
  'bx bx-pause',
  'bx bx-pause-circle',
  'bx bx-moon',
  'bx bx-minus-circle',
  'bx bx-microphone',
  'bx bx-menu',
  'bx bx-left-top-arrow-circle',
  'bx bx-left-indent',
  'bx bx-left-down-arrow-circle',
  'bx bx-left-arrow-circle',
  'bx bx-last-page',
  'bx bx-key',
  'bx bx-align-justify',
  'bx bx-info-circle',
  'bx bx-image',
  'bx bx-hide',
  'bx bx-fullscreen',
  'bx bx-folder',
  'bx bx-folder-plus',
  'bx bx-folder-minus',
  'bx bx-first-page',
  'bx bx-fast-forward',
  'bx bx-fast-forward-circle',
  'bx bx-exit-fullscreen',
  'bx bx-error',
  'bx bx-error-circle',
  'bx bx-down-arrow-circle',
  'bx bx-copyright',
  'bx bx-copy',
  'bx bx-coffee',
  'bx bx-code',
  'bx bx-code-curly',
  'bx bx-clipboard',
  'bx bx-chevrons-left',
  'bx bx-chevrons-right',
  'bx bx-chevrons-up',
  'bx bx-chevrons-down',
  'bx bx-chevron-right',
  'bx bx-chevron-left',
  'bx bx-chevron-up',
  'bx bx-chevron-down',
  'bx bx-checkbox-square',
  'bx bx-checkbox',
  'bx bx-checkbox-checked',
  'bx bx-captions',
  'bx bx-camera',
  'bx bx-camera-off',
  'bx bx-bullseye',
  'bx bx-bookmarks',
  'bx bx-bookmark',
  'bx bx-bell',
  'bx bx-bell-plus',
  'bx bx-bell-off',
  'bx bx-bell-minus',
  'bx bx-arrow-back',
  'bx bx-align-right',
  'bx bx-align-middle',
  'bx bx-align-left',
  'bx bx-music',
  'bx bx-upside-down',
  'bx bx-laugh',
  'bx bx-meh-blank',
  'bx bx-happy-beaming',
  'bx bx-shocked',
  'bx bx-sleepy',
  'bx bx-confused',
  'bx bx-wink-smile',
  'bx bx-dizzy',
  'bx bx-happy-heart-eyes',
  'bx bx-angry',
  'bx bx-smile',
  'bx bx-tired',
  'bx bx-cool',
  'bx bx-happy-alt',
  'bx bx-wink-tongue',
  'bx bx-meh-alt',
  'bx bx-food-menu',
  'bx bx-food-tag',
  'bx bx-female-sign',
  'bx bx-male-sign',
  'bx bx-female',
  'bx bx-male',
  'bx bx-clinic',
  'bx bx-health',
  'bx bx-shekel',
  'bx bx-yen',
  'bx bx-won',
  'bx bx-pound',
  'bx bx-euro',
  'bx bx-rupee',
  'bx bx-ruble',
  'bx bx-lira',
  'bx bx-bitcoin',
  'bx bx-tone',
  'bx bx-bolt-circle',
  'bx bx-cake',
  'bx bx-spa',
  'bx bx-dish',
  'bx bx-fridge',
  'bx bx-image-add',
  'bx bx-image-alt',
  'bx bx-space-bar',
  'bx bx-alarm-add',
  'bx bx-archive-out',
  'bx bx-archive-in',
  'bx bx-add-to-queue',
  'bx bx-border-radius',
  'bx bx-check-shield',
  'bx bx-label',
  'bx bx-file-find',
  'bx bx-face',
  'bx bx-extension',
  'bx bx-exit',
  'bx bx-conversation',
  'bx bx-sort-z-a',
  'bx bx-sort-a-z',
  'bx bx-printer',
  'bx bx-radio',
  'bx bx-customize',
  'bx bx-brush-alt',
  'bx bx-briefcase-alt-2',
  'bx bx-time-five',
  'bx bx-pie-chart-alt-2',
  'bx bx-gas-pump',
  'bx bx-mobile-vibration',
  'bx bx-mobile-landscape',
  'bx bx-border-all',
  'bx bx-border-bottom',
  'bx bx-border-top',
  'bx bx-border-left',
  'bx bx-border-right',
  'bx bx-dialpad-alt',
  'bx bx-filter-alt',
  'bx bx-brightness',
  'bx bx-brightness-half',
  'bx bx-wifi-off',
  'bx bx-credit-card-alt',
  'bx bx-band-aid',
  'bx bx-hive',
  'bx bx-map-pin',
  'bx bx-line-chart',
  'bx bx-receipt',
  'bx bx-purchase-tag-alt',
  'bx bx-basket',
  'bx bx-palette',
  'bx bx-no-entry',
  'bx bx-message-alt-dots',
  'bx bx-message-alt',
  'bx bx-check-square',
  'bx bx-log-out-circle',
  'bx bx-log-in-circle',
  'bx bx-doughnut-chart',
  'bx bx-building-house',
  'bx bx-accessibility',
  'bx bx-user-voice',
  'bx bx-cuboid',
  'bx bx-cube-alt',
  'bx bx-polygon',
  'bx bx-square-rounded',
  'bx bx-square',
  'bx bx-error-alt',
  'bx bx-shield-alt-2',
  'bx bx-paint-roll',
  'bx bx-droplet',
  'bx bx-street-view',
  'bx bx-plus-medical',
  'bx bx-search-alt-2',
  'bx bx-bowling-ball',
  'bx bx-dna',
  'bx bx-cycling',
  'bx bx-shape-circle',
  'bx bx-down-arrow-alt',
  'bx bx-up-arrow-alt',
  'bx bx-right-arrow-alt',
  'bx bx-left-arrow-alt',
  'bx bx-lock-open-alt',
  'bx bx-lock-alt',
  'bx bx-cylinder',
  'bx bx-pyramid',
  'bx bx-comment-dots',
  'bx bx-comment',
  'bx bx-landscape',
  'bx bx-book-open',
  'bx bx-transfer-alt',
  'bx bx-copy-alt',
  'bx bx-run',
  'bx bx-user-pin',
  'bx bx-grid',
  'bx bx-code-alt',
  'bx bx-mail-send',
  'bx bx-ghost',
];

export const FA_SOLID = [
  'fas fa-ad',
  'fas fa-address-book',
  'fas fa-address-card',
  'fas fa-adjust',
  'fas fa-air-freshener',
  'fas fa-align-center',
  'fas fa-align-justify',
  'fas fa-align-left',
  'fas fa-align-right',
  'fas fa-allergies',
  'fas fa-ambulance',
  'fas fa-american-sign-language-interpreting',
  'fas fa-anchor',
  'fas fa-angle-double-down',
  'fas fa-angle-double-left',
  'fas fa-angle-double-right',
  'fas fa-angle-double-up',
  'fas fa-angle-down',
  'fas fa-angle-left',
  'fas fa-angle-right',
  'fas fa-angle-up',
  'fas fa-angry',
  'fas fa-ankh',
  'fas fa-apple-alt',
  'fas fa-archive',
  'fas fa-archway',
  'fas fa-arrow-alt-circle-down',
  'fas fa-arrow-alt-circle-left',
  'fas fa-arrow-alt-circle-right',
  'fas fa-arrow-alt-circle-up',
  'fas fa-arrow-circle-down',
  'fas fa-arrow-circle-left',
  'fas fa-arrow-circle-right',
  'fas fa-arrow-circle-up',
  'fas fa-arrow-down',
  'fas fa-arrow-left',
  'fas fa-arrow-right',
  'fas fa-arrow-up',
  'fas fa-arrows-alt',
  'fas fa-arrows-alt-h',
  'fas fa-arrows-alt-v',
  'fas fa-assistive-listening-systems',
  'fas fa-asterisk',
  'fas fa-at',
  'fas fa-atlas',
  'fas fa-atom',
  'fas fa-audio-description',
  'fas fa-award',
  'fas fa-baby',
  'fas fa-baby-carriage',
  'fas fa-backspace',
  'fas fa-backward',
  'fas fa-bacon',
  'fas fa-bahai',
  'fas fa-balance-scale',
  'fas fa-balance-scale-left',
  'fas fa-balance-scale-right',
  'fas fa-ban',
  'fas fa-band-aid',
  'fas fa-barcode',
  'fas fa-bars',
  'fas fa-baseball-ball',
  'fas fa-basketball-ball',
  'fas fa-bath',
  'fas fa-battery-empty',
  'fas fa-battery-full',
  'fas fa-battery-half',
  'fas fa-battery-quarter',
  'fas fa-battery-three-quarters',
  'fas fa-bed',
  'fas fa-beer',
  'fas fa-bell',
  'fas fa-bell-slash',
  'fas fa-bezier-curve',
  'fas fa-bible',
  'fas fa-bicycle',
  'fas fa-biking',
  'fas fa-binoculars',
  'fas fa-biohazard',
  'fas fa-birthday-cake',
  'fas fa-blender',
  'fas fa-blender-phone',
  'fas fa-blind',
  'fas fa-blog',
  'fas fa-bold',
  'fas fa-bolt',
  'fas fa-bomb',
  'fas fa-bone',
  'fas fa-bong',
  'fas fa-book',
  'fas fa-book-dead',
  'fas fa-book-medical',
  'fas fa-book-open',
  'fas fa-book-reader',
  'fas fa-bookmark',
  'fas fa-border-all',
  'fas fa-border-none',
  'fas fa-border-style',
  'fas fa-bowling-ball',
  'fas fa-box',
  'fas fa-box-open',
  'fas fa-box-tissue',
  'fas fa-boxes',
  'fas fa-braille',
  'fas fa-brain',
  'fas fa-bread-slice',
  'fas fa-briefcase',
  'fas fa-briefcase-medical',
  'fas fa-broadcast-tower',
  'fas fa-broom',
  'fas fa-brush',
  'fas fa-bug',
  'fas fa-building',
  'fas fa-bullhorn',
  'fas fa-bullseye',
  'fas fa-burn',
  'fas fa-bus',
  'fas fa-bus-alt',
  'fas fa-business-time',
  'fas fa-calculator',
  'fas fa-calendar',
  'fas fa-calendar-alt',
  'fas fa-calendar-check',
  'fas fa-calendar-day',
  'fas fa-calendar-minus',
  'fas fa-calendar-plus',
  'fas fa-calendar-times',
  'fas fa-calendar-week',
  'fas fa-camera',
  'fas fa-camera-retro',
  'fas fa-campground',
  'fas fa-candy-cane',
  'fas fa-cannabis',
  'fas fa-capsules',
  'fas fa-car',
  'fas fa-car-alt',
  'fas fa-car-battery',
  'fas fa-car-crash',
  'fas fa-car-side',
  'fas fa-caravan',
  'fas fa-caret-down',
  'fas fa-caret-left',
  'fas fa-caret-right',
  'fas fa-caret-square-down',
  'fas fa-caret-square-left',
  'fas fa-caret-square-right',
  'fas fa-caret-square-up',
  'fas fa-caret-up',
  'fas fa-carrot',
  'fas fa-cart-arrow-down',
  'fas fa-cart-plus',
  'fas fa-cash-register',
  'fas fa-cat',
  'fas fa-certificate',
  'fas fa-chair',
  'fas fa-chalkboard',
  'fas fa-chalkboard-teacher',
  'fas fa-charging-station',
  'fas fa-chart-area',
  'fas fa-chart-bar',
  'fas fa-chart-line',
  'fas fa-chart-pie',
  'fas fa-check',
  'fas fa-check-circle',
  'fas fa-check-double',
  'fas fa-check-square',
  'fas fa-cheese',
  'fas fa-chess',
  'fas fa-chess-bishop',
  'fas fa-chess-board',
  'fas fa-chess-king',
  'fas fa-chess-knight',
  'fas fa-chess-pawn',
  'fas fa-chess-queen',
  'fas fa-chess-rook',
  'fas fa-chevron-circle-down',
  'fas fa-chevron-circle-left',
  'fas fa-chevron-circle-right',
  'fas fa-chevron-circle-up',
  'fas fa-chevron-down',
  'fas fa-chevron-left',
  'fas fa-chevron-right',
  'fas fa-chevron-up',
  'fas fa-child',
  'fas fa-church',
  'fas fa-circle',
  'fas fa-circle-notch',
  'fas fa-city',
  'fas fa-clinic-medical',
  'fas fa-clipboard',
  'fas fa-clipboard-check',
  'fas fa-clipboard-list',
  'fas fa-clock',
  'fas fa-clone',
  'fas fa-closed-captioning',
  'fas fa-cloud',
  'fas fa-cloud-download-alt',
  'fas fa-cloud-meatball',
  'fas fa-cloud-moon',
  'fas fa-cloud-moon-rain',
  'fas fa-cloud-rain',
  'fas fa-cloud-showers-heavy',
  'fas fa-cloud-sun',
  'fas fa-cloud-sun-rain',
  'fas fa-cloud-upload-alt',
  'fas fa-cocktail',
  'fas fa-code',
  'fas fa-code-branch',
  'fas fa-coffee',
  'fas fa-cog',
  'fas fa-cogs',
  'fas fa-coins',
  'fas fa-columns',
  'fas fa-comment',
  'fas fa-comment-alt',
  'fas fa-comment-dollar',
  'fas fa-comment-dots',
  'fas fa-comment-medical',
  'fas fa-comment-slash',
  'fas fa-comments',
  'fas fa-comments-dollar',
  'fas fa-compact-disc',
  'fas fa-compass',
  'fas fa-compress',
  'fas fa-compress-alt',
  'fas fa-compress-arrows-alt',
  'fas fa-concierge-bell',
  'fas fa-cookie',
  'fas fa-cookie-bite',
  'fas fa-copy',
  'fas fa-copyright',
  'fas fa-couch',
  'fas fa-credit-card',
  'fas fa-crop',
  'fas fa-crop-alt',
  'fas fa-cross',
  'fas fa-crosshairs',
  'fas fa-crow',
  'fas fa-crown',
  'fas fa-crutch',
  'fas fa-cube',
  'fas fa-cubes',
  'fas fa-cut',
  'fas fa-database',
  'fas fa-deaf',
  'fas fa-democrat',
  'fas fa-desktop',
  'fas fa-dharmachakra',
  'fas fa-diagnoses',
  'fas fa-dice',
  'fas fa-dice-d20',
  'fas fa-dice-d6',
  'fas fa-dice-five',
  'fas fa-dice-four',
  'fas fa-dice-one',
  'fas fa-dice-six',
  'fas fa-dice-three',
  'fas fa-dice-two',
  'fas fa-digital-tachograph',
  'fas fa-directions',
  'fas fa-disease',
  'fas fa-divide',
  'fas fa-dizzy',
  'fas fa-dna',
  'fas fa-dog',
  'fas fa-dollar-sign',
  'fas fa-dolly',
  'fas fa-dolly-flatbed',
  'fas fa-donate',
  'fas fa-door-closed',
  'fas fa-door-open',
  'fas fa-dot-circle',
  'fas fa-dove',
  'fas fa-download',
  'fas fa-drafting-compass',
  'fas fa-dragon',
  'fas fa-draw-polygon',
  'fas fa-drum',
  'fas fa-drum-steelpan',
  'fas fa-drumstick-bite',
  'fas fa-dumbbell',
  'fas fa-dumpster',
  'fas fa-dumpster-fire',
  'fas fa-dungeon',
  'fas fa-edit',
  'fas fa-egg',
  'fas fa-eject',
  'fas fa-ellipsis-h',
  'fas fa-ellipsis-v',
  'fas fa-envelope',
  'fas fa-envelope-open',
  'fas fa-envelope-open-text',
  'fas fa-envelope-square',
  'fas fa-equals',
  'fas fa-eraser',
  'fas fa-ethernet',
  'fas fa-euro-sign',
  'fas fa-exchange-alt',
  'fas fa-exclamation',
  'fas fa-exclamation-circle',
  'fas fa-exclamation-triangle',
  'fas fa-expand',
  'fas fa-expand-alt',
  'fas fa-expand-arrows-alt',
  'fas fa-external-link-alt',
  'fas fa-external-link-square-alt',
  'fas fa-eye',
  'fas fa-eye-dropper',
  'fas fa-eye-slash',
  'fas fa-fan',
  'fas fa-fast-backward',
  'fas fa-fast-forward',
  'fas fa-faucet',
  'fas fa-fax',
  'fas fa-feather',
  'fas fa-feather-alt',
  'fas fa-female',
  'fas fa-fighter-jet',
  'fas fa-file',
  'fas fa-file-alt',
  'fas fa-file-archive',
  'fas fa-file-audio',
  'fas fa-file-code',
  'fas fa-file-contract',
  'fas fa-file-csv',
  'fas fa-file-download',
  'fas fa-file-excel',
  'fas fa-file-export',
  'fas fa-file-image',
  'fas fa-file-import',
  'fas fa-file-invoice',
  'fas fa-file-invoice-dollar',
  'fas fa-file-medical',
  'fas fa-file-medical-alt',
  'fas fa-file-pdf',
  'fas fa-file-powerpoint',
  'fas fa-file-prescription',
  'fas fa-file-signature',
  'fas fa-file-upload',
  'fas fa-file-video',
  'fas fa-file-word',
  'fas fa-fill',
  'fas fa-fill-drip',
  'fas fa-film',
  'fas fa-filter',
  'fas fa-fingerprint',
  'fas fa-fire',
  'fas fa-fire-alt',
  'fas fa-fire-extinguisher',
  'fas fa-first-aid',
  'fas fa-fish',
  'fas fa-fist-raised',
  'fas fa-flag',
  'fas fa-flag-checkered',
  'fas fa-flag-usa',
  'fas fa-flask',
  'fas fa-flushed',
  'fas fa-folder',
  'fas fa-folder-minus',
  'fas fa-folder-open',
  'fas fa-folder-plus',
  'fas fa-font',
  'fas fa-football-ball',
  'fas fa-forward',
  'fas fa-frog',
  'fas fa-frown',
  'fas fa-frown-open',
  'fas fa-funnel-dollar',
  'fas fa-futbol',
  'fas fa-gamepad',
  'fas fa-gas-pump',
  'fas fa-gavel',
  'fas fa-gem',
  'fas fa-genderless',
  'fas fa-ghost',
  'fas fa-gift',
  'fas fa-gifts',
  'fas fa-glass-cheers',
  'fas fa-glass-martini',
  'fas fa-glass-martini-alt',
  'fas fa-glass-whiskey',
  'fas fa-glasses',
  'fas fa-globe',
  'fas fa-globe-africa',
  'fas fa-globe-americas',
  'fas fa-globe-asia',
  'fas fa-globe-europe',
  'fas fa-golf-ball',
  'fas fa-gopuram',
  'fas fa-graduation-cap',
  'fas fa-greater-than',
  'fas fa-greater-than-equal',
  'fas fa-grimace',
  'fas fa-grin',
  'fas fa-grin-alt',
  'fas fa-grin-beam',
  'fas fa-grin-beam-sweat',
  'fas fa-grin-hearts',
  'fas fa-grin-squint',
  'fas fa-grin-squint-tears',
  'fas fa-grin-stars',
  'fas fa-grin-tears',
  'fas fa-grin-tongue',
  'fas fa-grin-tongue-squint',
  'fas fa-grin-tongue-wink',
  'fas fa-grin-wink',
  'fas fa-grip-horizontal',
  'fas fa-grip-lines',
  'fas fa-grip-lines-vertical',
  'fas fa-grip-vertical',
  'fas fa-guitar',
  'fas fa-h-square',
  'fas fa-hamburger',
  'fas fa-hammer',
  'fas fa-hamsa',
  'fas fa-hand-holding',
  'fas fa-hand-holding-heart',
  'fas fa-hand-holding-medical',
  'fas fa-hand-holding-usd',
  'fas fa-hand-holding-water',
  'fas fa-hand-lizard',
  'fas fa-hand-middle-finger',
  'fas fa-hand-paper',
  'fas fa-hand-peace',
  'fas fa-hand-point-down',
  'fas fa-hand-point-left',
  'fas fa-hand-point-right',
  'fas fa-hand-point-up',
  'fas fa-hand-pointer',
  'fas fa-hand-rock',
  'fas fa-hand-scissors',
  'fas fa-hand-sparkles',
  'fas fa-hand-spock',
  'fas fa-hands',
  'fas fa-hands-helping',
  'fas fa-hands-wash',
  'fas fa-handshake',
  'fas fa-handshake-alt-slash',
  'fas fa-handshake-slash',
  'fas fa-hanukiah',
  'fas fa-hard-hat',
  'fas fa-hashtag',
  'fas fa-hat-cowboy',
  'fas fa-hat-cowboy-side',
  'fas fa-hat-wizard',
  'fas fa-hdd',
  'fas fa-head-side-cough',
  'fas fa-head-side-cough-slash',
  'fas fa-head-side-mask',
  'fas fa-head-side-virus',
  'fas fa-heading',
  'fas fa-headphones',
  'fas fa-headphones-alt',
  'fas fa-headset',
  'fas fa-heart',
  'fas fa-heart-broken',
  'fas fa-heartbeat',
  'fas fa-helicopter',
  'fas fa-highlighter',
  'fas fa-hiking',
  'fas fa-hippo',
  'fas fa-history',
  'fas fa-hockey-puck',
  'fas fa-holly-berry',
  'fas fa-home',
  'fas fa-horse',
  'fas fa-horse-head',
  'fas fa-hospital',
  'fas fa-hospital-alt',
  'fas fa-hospital-symbol',
  'fas fa-hospital-user',
  'fas fa-hot-tub',
  'fas fa-hotdog',
  'fas fa-hotel',
  'fas fa-hourglass',
  'fas fa-hourglass-end',
  'fas fa-hourglass-half',
  'fas fa-hourglass-start',
  'fas fa-house-damage',
  'fas fa-house-user',
  'fas fa-hryvnia',
  'fas fa-i-cursor',
  'fas fa-ice-cream',
  'fas fa-icicles',
  'fas fa-icons',
  'fas fa-id-badge',
  'fas fa-id-card',
  'fas fa-id-card-alt',
  'fas fa-igloo',
  'fas fa-image',
  'fas fa-images',
  'fas fa-inbox',
  'fas fa-indent',
  'fas fa-industry',
  'fas fa-infinity',
  'fas fa-info',
  'fas fa-info-circle',
  'fas fa-italic',
  'fas fa-jedi',
  'fas fa-joint',
  'fas fa-journal-whills',
  'fas fa-kaaba',
  'fas fa-key',
  'fas fa-keyboard',
  'fas fa-khanda',
  'fas fa-kiss',
  'fas fa-kiss-beam',
  'fas fa-kiss-wink-heart',
  'fas fa-kiwi-bird',
  'fas fa-landmark',
  'fas fa-language',
  'fas fa-laptop',
  'fas fa-laptop-code',
  'fas fa-laptop-house',
  'fas fa-laptop-medical',
  'fas fa-laugh',
  'fas fa-laugh-beam',
  'fas fa-laugh-squint',
  'fas fa-laugh-wink',
  'fas fa-layer-group',
  'fas fa-leaf',
  'fas fa-lemon',
  'fas fa-less-than',
  'fas fa-less-than-equal',
  'fas fa-level-down-alt',
  'fas fa-level-up-alt',
  'fas fa-life-ring',
  'fas fa-lightbulb',
  'fas fa-link',
  'fas fa-lira-sign',
  'fas fa-list',
  'fas fa-list-alt',
  'fas fa-list-ol',
  'fas fa-list-ul',
  'fas fa-location-arrow',
  'fas fa-lock',
  'fas fa-lock-open',
  'fas fa-long-arrow-alt-down',
  'fas fa-long-arrow-alt-left',
  'fas fa-long-arrow-alt-right',
  'fas fa-long-arrow-alt-up',
  'fas fa-low-vision',
  'fas fa-luggage-cart',
  'fas fa-lungs',
  'fas fa-lungs-virus',
  'fas fa-magic',
  'fas fa-magnet',
  'fas fa-mail-bulk',
  'fas fa-male',
  'fas fa-map',
  'fas fa-map-marked',
  'fas fa-map-marked-alt',
  'fas fa-map-marker',
  'fas fa-map-marker-alt',
  'fas fa-map-pin',
  'fas fa-map-signs',
  'fas fa-marker',
  'fas fa-mars',
  'fas fa-mars-double',
  'fas fa-mars-stroke',
  'fas fa-mars-stroke-h',
  'fas fa-mars-stroke-v',
  'fas fa-mask',
  'fas fa-medal',
  'fas fa-medkit',
  'fas fa-meh',
  'fas fa-meh-blank',
  'fas fa-meh-rolling-eyes',
  'fas fa-memory',
  'fas fa-menorah',
  'fas fa-mercury',
  'fas fa-meteor',
  'fas fa-microchip',
  'fas fa-microphone',
  'fas fa-microphone-alt',
  'fas fa-microphone-alt-slash',
  'fas fa-microphone-slash',
  'fas fa-microscope',
  'fas fa-minus',
  'fas fa-minus-circle',
  'fas fa-minus-square',
  'fas fa-mitten',
  'fas fa-mobile',
  'fas fa-mobile-alt',
  'fas fa-money-bill',
  'fas fa-money-bill-alt',
  'fas fa-money-bill-wave',
  'fas fa-money-bill-wave-alt',
  'fas fa-money-check',
  'fas fa-money-check-alt',
  'fas fa-monument',
  'fas fa-moon',
  'fas fa-mortar-pestle',
  'fas fa-mosque',
  'fas fa-motorcycle',
  'fas fa-mountain',
  'fas fa-mouse',
  'fas fa-mouse-pointer',
  'fas fa-mug-hot',
  'fas fa-music',
  'fas fa-network-wired',
  'fas fa-neuter',
  'fas fa-newspaper',
  'fas fa-not-equal',
  'fas fa-notes-medical',
  'fas fa-object-group',
  'fas fa-object-ungroup',
  'fas fa-oil-can',
  'fas fa-om',
  'fas fa-otter',
  'fas fa-outdent',
  'fas fa-pager',
  'fas fa-paint-brush',
  'fas fa-paint-roller',
  'fas fa-palette',
  'fas fa-pallet',
  'fas fa-paper-plane',
  'fas fa-paperclip',
  'fas fa-parachute-box',
  'fas fa-paragraph',
  'fas fa-parking',
  'fas fa-passport',
  'fas fa-pastafarianism',
  'fas fa-paste',
  'fas fa-pause',
  'fas fa-pause-circle',
  'fas fa-paw',
  'fas fa-peace',
  'fas fa-pen',
  'fas fa-pen-alt',
  'fas fa-pen-fancy',
  'fas fa-pen-nib',
  'fas fa-pen-square',
  'fas fa-pencil-alt',
  'fas fa-pencil-ruler',
  'fas fa-people-arrows',
  'fas fa-people-carry',
  'fas fa-pepper-hot',
  'fas fa-percent',
  'fas fa-percentage',
  'fas fa-person-booth',
  'fas fa-phone',
  'fas fa-phone-alt',
  'fas fa-phone-slash',
  'fas fa-phone-square',
  'fas fa-phone-square-alt',
  'fas fa-phone-volume',
  'fas fa-photo-video',
  'fas fa-piggy-bank',
  'fas fa-pills',
  'fas fa-pizza-slice',
  'fas fa-place-of-worship',
  'fas fa-plane',
  'fas fa-plane-arrival',
  'fas fa-plane-departure',
  'fas fa-plane-slash',
  'fas fa-play',
  'fas fa-play-circle',
  'fas fa-plug',
  'fas fa-plus',
  'fas fa-plus-circle',
  'fas fa-plus-square',
  'fas fa-podcast',
  'fas fa-poll',
  'fas fa-poll-h',
  'fas fa-poo',
  'fas fa-poo-storm',
  'fas fa-poop',
  'fas fa-portrait',
  'fas fa-pound-sign',
  'fas fa-power-off',
  'fas fa-pray',
  'fas fa-praying-hands',
  'fas fa-prescription',
  'fas fa-prescription-bottle',
  'fas fa-prescription-bottle-alt',
  'fas fa-print',
  'fas fa-procedures',
  'fas fa-project-diagram',
  'fas fa-pump-medical',
  'fas fa-pump-soap',
  'fas fa-puzzle-piece',
  'fas fa-qrcode',
  'fas fa-question',
  'fas fa-question-circle',
  'fas fa-quidditch',
  'fas fa-quote-left',
  'fas fa-quote-right',
  'fas fa-quran',
  'fas fa-radiation',
  'fas fa-radiation-alt',
  'fas fa-rainbow',
  'fas fa-random',
  'fas fa-receipt',
  'fas fa-record-vinyl',
  'fas fa-recycle',
  'fas fa-redo',
  'fas fa-redo-alt',
  'fas fa-registered',
  'fas fa-remove-format',
  'fas fa-reply',
  'fas fa-reply-all',
  'fas fa-republican',
  'fas fa-restroom',
  'fas fa-retweet',
  'fas fa-ribbon',
  'fas fa-ring',
  'fas fa-road',
  'fas fa-robot',
  'fas fa-rocket',
  'fas fa-route',
  'fas fa-rss',
  'fas fa-rss-square',
  'fas fa-ruble-sign',
  'fas fa-ruler',
  'fas fa-ruler-combined',
  'fas fa-ruler-horizontal',
  'fas fa-ruler-vertical',
  'fas fa-running',
  'fas fa-rupee-sign',
  'fas fa-sad-cry',
  'fas fa-sad-tear',
  'fas fa-satellite',
  'fas fa-satellite-dish',
  'fas fa-save',
  'fas fa-school',
  'fas fa-screwdriver',
  'fas fa-scroll',
  'fas fa-sd-card',
  'fas fa-search',
  'fas fa-search-dollar',
  'fas fa-search-location',
  'fas fa-search-minus',
  'fas fa-search-plus',
  'fas fa-seedling',
  'fas fa-server',
  'fas fa-shapes',
  'fas fa-share',
  'fas fa-share-alt',
  'fas fa-share-alt-square',
  'fas fa-share-square',
  'fas fa-shekel-sign',
  'fas fa-shield-alt',
  'fas fa-shield-virus',
  'fas fa-ship',
  'fas fa-shipping-fast',
  'fas fa-shoe-prints',
  'fas fa-shopping-bag',
  'fas fa-shopping-basket',
  'fas fa-shopping-cart',
  'fas fa-shower',
  'fas fa-shuttle-van',
  'fas fa-sign',
  'fas fa-sign-in-alt',
  'fas fa-sign-language',
  'fas fa-sign-out-alt',
  'fas fa-signal',
  'fas fa-signature',
  'fas fa-sim-card',
  'fas fa-sitemap',
  'fas fa-skating',
  'fas fa-skiing',
  'fas fa-skiing-nordic',
  'fas fa-skull',
  'fas fa-skull-crossbones',
  'fas fa-slash',
  'fas fa-sleigh',
  'fas fa-sliders-h',
  'fas fa-smile',
  'fas fa-smile-beam',
  'fas fa-smile-wink',
  'fas fa-smog',
  'fas fa-smoking',
  'fas fa-smoking-ban',
  'fas fa-sms',
  'fas fa-snowboarding',
  'fas fa-snowflake',
  'fas fa-snowman',
  'fas fa-snowplow',
  'fas fa-soap',
  'fas fa-socks',
  'fas fa-solar-panel',
  'fas fa-sort',
  'fas fa-sort-alpha-down',
  'fas fa-sort-alpha-down-alt',
  'fas fa-sort-alpha-up',
  'fas fa-sort-alpha-up-alt',
  'fas fa-sort-amount-down',
  'fas fa-sort-amount-down-alt',
  'fas fa-sort-amount-up',
  'fas fa-sort-amount-up-alt',
  'fas fa-sort-down',
  'fas fa-sort-numeric-down',
  'fas fa-sort-numeric-down-alt',
  'fas fa-sort-numeric-up',
  'fas fa-sort-numeric-up-alt',
  'fas fa-sort-up',
  'fas fa-spa',
  'fas fa-space-shuttle',
  'fas fa-spell-check',
  'fas fa-spider',
  'fas fa-spinner',
  'fas fa-splotch',
  'fas fa-spray-can',
  'fas fa-square',
  'fas fa-square-full',
  'fas fa-square-root-alt',
  'fas fa-stamp',
  'fas fa-star',
  'fas fa-star-and-crescent',
  'fas fa-star-half',
  'fas fa-star-half-alt',
  'fas fa-star-of-david',
  'fas fa-star-of-life',
  'fas fa-step-backward',
  'fas fa-step-forward',
  'fas fa-stethoscope',
  'fas fa-sticky-note',
  'fas fa-stop',
  'fas fa-stop-circle',
  'fas fa-stopwatch',
  'fas fa-stopwatch-20',
  'fas fa-store',
  'fas fa-store-alt',
  'fas fa-store-alt-slash',
  'fas fa-store-slash',
  'fas fa-stream',
  'fas fa-street-view',
  'fas fa-strikethrough',
  'fas fa-stroopwafel',
  'fas fa-subscript',
  'fas fa-subway',
  'fas fa-suitcase',
  'fas fa-suitcase-rolling',
  'fas fa-sun',
  'fas fa-superscript',
  'fas fa-surprise',
  'fas fa-swatchbook',
  'fas fa-swimmer',
  'fas fa-swimming-pool',
  'fas fa-synagogue',
  'fas fa-sync',
  'fas fa-sync-alt',
  'fas fa-syringe',
  'fas fa-table',
  'fas fa-table-tennis',
  'fas fa-tablet',
  'fas fa-tablet-alt',
  'fas fa-tablets',
  'fas fa-tachometer-alt',
  'fas fa-tag',
  'fas fa-tags',
  'fas fa-tape',
  'fas fa-tasks',
  'fas fa-taxi',
  'fas fa-teeth',
  'fas fa-teeth-open',
  'fas fa-temperature-high',
  'fas fa-temperature-low',
  'fas fa-tenge',
  'fas fa-terminal',
  'fas fa-text-height',
  'fas fa-text-width',
  'fas fa-th',
  'fas fa-th-large',
  'fas fa-th-list',
  'fas fa-theater-masks',
  'fas fa-thermometer',
  'fas fa-thermometer-empty',
  'fas fa-thermometer-full',
  'fas fa-thermometer-half',
  'fas fa-thermometer-quarter',
  'fas fa-thermometer-three-quarters',
  'fas fa-thumbs-down',
  'fas fa-thumbs-up',
  'fas fa-thumbtack',
  'fas fa-ticket-alt',
  'fas fa-times',
  'fas fa-times-circle',
  'fas fa-tint',
  'fas fa-tint-slash',
  'fas fa-tired',
  'fas fa-toggle-off',
  'fas fa-toggle-on',
  'fas fa-toilet',
  'fas fa-toilet-paper',
  'fas fa-toilet-paper-slash',
  'fas fa-toolbox',
  'fas fa-tools',
  'fas fa-tooth',
  'fas fa-torah',
  'fas fa-torii-gate',
  'fas fa-tractor',
  'fas fa-trademark',
  'fas fa-traffic-light',
  'fas fa-trailer',
  'fas fa-train',
  'fas fa-tram',
  'fas fa-transgender',
  'fas fa-transgender-alt',
  'fas fa-trash',
  'fas fa-trash-alt',
  'fas fa-trash-restore',
  'fas fa-trash-restore-alt',
  'fas fa-tree',
  'fas fa-trophy',
  'fas fa-truck',
  'fas fa-truck-loading',
  'fas fa-truck-monster',
  'fas fa-truck-moving',
  'fas fa-truck-pickup',
  'fas fa-tshirt',
  'fas fa-tty',
  'fas fa-tv',
  'fas fa-umbrella',
  'fas fa-umbrella-beach',
  'fas fa-underline',
  'fas fa-undo',
  'fas fa-undo-alt',
  'fas fa-universal-access',
  'fas fa-university',
  'fas fa-unlink',
  'fas fa-unlock',
  'fas fa-unlock-alt',
  'fas fa-upload',
  'fas fa-user',
  'fas fa-user-alt',
  'fas fa-user-alt-slash',
  'fas fa-user-astronaut',
  'fas fa-user-check',
  'fas fa-user-circle',
  'fas fa-user-clock',
  'fas fa-user-cog',
  'fas fa-user-edit',
  'fas fa-user-friends',
  'fas fa-user-graduate',
  'fas fa-user-injured',
  'fas fa-user-lock',
  'fas fa-user-md',
  'fas fa-user-minus',
  'fas fa-user-ninja',
  'fas fa-user-nurse',
  'fas fa-user-plus',
  'fas fa-user-secret',
  'fas fa-user-shield',
  'fas fa-user-slash',
  'fas fa-user-tag',
  'fas fa-user-tie',
  'fas fa-user-times',
  'fas fa-users',
  'fas fa-users-cog',
  'fas fa-utensil-spoon',
  'fas fa-utensils',
  'fas fa-vector-square',
  'fas fa-venus',
  'fas fa-venus-double',
  'fas fa-venus-mars',
  'fas fa-vial',
  'fas fa-vials',
  'fas fa-video',
  'fas fa-video-slash',
  'fas fa-vihara',
  'fas fa-virus',
  'fas fa-virus-slash',
  'fas fa-viruses',
  'fas fa-voicemail',
  'fas fa-volleyball-ball',
  'fas fa-volume-down',
  'fas fa-volume-mute',
  'fas fa-volume-off',
  'fas fa-volume-up',
  'fas fa-vote-yea',
  'fas fa-vr-cardboard',
  'fas fa-walking',
  'fas fa-wallet',
  'fas fa-warehouse',
  'fas fa-water',
  'fas fa-wave-square',
  'fas fa-weight',
  'fas fa-weight-hanging',
  'fas fa-wheelchair',
  'fas fa-wifi',
  'fas fa-wind',
  'fas fa-window-close',
  'fas fa-window-maximize',
  'fas fa-window-minimize',
  'fas fa-window-restore',
  'fas fa-wine-bottle',
  'fas fa-wine-glass',
  'fas fa-wine-glass-alt',
  'fas fa-won-sign',
  'fas fa-wrench',
  'fas fa-x-ray',
  'fas fa-yen-sign',
  'fas fa-yin-yang',
];

export const FA_REGULAR = [
  'far fa-address-book',
  'far fa-address-card',
  'far fa-angry',
  'far fa-arrow-alt-circle-down',
  'far fa-arrow-alt-circle-left',
  'far fa-arrow-alt-circle-right',
  'far fa-arrow-alt-circle-up',
  'far fa-bell',
  'far fa-bell-slash',
  'far fa-bookmark',
  'far fa-building',
  'far fa-calendar',
  'far fa-calendar-alt',
  'far fa-calendar-check',
  'far fa-calendar-minus',
  'far fa-calendar-plus',
  'far fa-calendar-times',
  'far fa-caret-square-down',
  'far fa-caret-square-left',
  'far fa-caret-square-right',
  'far fa-caret-square-up',
  'far fa-chart-bar',
  'far fa-check-circle',
  'far fa-check-square',
  'far fa-circle',
  'far fa-clipboard',
  'far fa-clock',
  'far fa-clone',
  'far fa-closed-captioning',
  'far fa-comment',
  'far fa-comment-alt',
  'far fa-comment-dots',
  'far fa-comments',
  'far fa-compass',
  'far fa-copy',
  'far fa-copyright',
  'far fa-credit-card',
  'far fa-dizzy',
  'far fa-dot-circle',
  'far fa-edit',
  'far fa-envelope',
  'far fa-envelope-open',
  'far fa-eye',
  'far fa-eye-slash',
  'far fa-file',
  'far fa-file-alt',
  'far fa-file-archive',
  'far fa-file-audio',
  'far fa-file-code',
  'far fa-file-excel',
  'far fa-file-image',
  'far fa-file-pdf',
  'far fa-file-powerpoint',
  'far fa-file-video',
  'far fa-file-word',
  'far fa-flag',
  'far fa-flushed',
  'far fa-folder',
  'far fa-folder-open',
  'far fa-frown',
  'far fa-frown-open',
  'far fa-futbol',
  'far fa-gem',
  'far fa-grimace',
  'far fa-grin',
  'far fa-grin-alt',
  'far fa-grin-beam',
  'far fa-grin-beam-sweat',
  'far fa-grin-hearts',
  'far fa-grin-squint',
  'far fa-grin-squint-tears',
  'far fa-grin-stars',
  'far fa-grin-tears',
  'far fa-grin-tongue',
  'far fa-grin-tongue-squint',
  'far fa-grin-tongue-wink',
  'far fa-grin-wink',
  'far fa-hand-lizard',
  'far fa-hand-paper',
  'far fa-hand-peace',
  'far fa-hand-point-down',
  'far fa-hand-point-left',
  'far fa-hand-point-right',
  'far fa-hand-point-up',
  'far fa-hand-pointer',
  'far fa-hand-rock',
  'far fa-hand-scissors',
  'far fa-hand-spock',
  'far fa-handshake',
  'far fa-hdd',
  'far fa-heart',
  'far fa-hospital',
  'far fa-hourglass',
  'far fa-id-badge',
  'far fa-id-card',
  'far fa-image',
  'far fa-images',
  'far fa-keyboard',
  'far fa-kiss',
  'far fa-kiss-beam',
  'far fa-kiss-wink-heart',
  'far fa-laugh',
  'far fa-laugh-beam',
  'far fa-laugh-squint',
  'far fa-laugh-wink',
  'far fa-lemon',
  'far fa-life-ring',
  'far fa-lightbulb',
  'far fa-list-alt',
  'far fa-map',
  'far fa-meh',
  'far fa-meh-blank',
  'far fa-meh-rolling-eyes',
  'far fa-minus-square',
  'far fa-money-bill-alt',
  'far fa-moon',
  'far fa-newspaper',
  'far fa-object-group',
  'far fa-object-ungroup',
  'far fa-paper-plane',
  'far fa-pause-circle',
  'far fa-play-circle',
  'far fa-plus-square',
  'far fa-question-circle',
  'far fa-registered',
  'far fa-sad-cry',
  'far fa-sad-tear',
  'far fa-save',
  'far fa-share-square',
  'far fa-smile',
  'far fa-smile-beam',
  'far fa-smile-wink',
  'far fa-snowflake',
  'far fa-square',
  'far fa-star',
  'far fa-star-half',
  'far fa-sticky-note',
  'far fa-stop-circle',
  'far fa-sun',
  'far fa-surprise',
  'far fa-thumbs-down',
  'far fa-thumbs-up',
  'far fa-times-circle',
  'far fa-tired',
  'far fa-trash-alt',
  'far fa-user',
  'far fa-user-circle',
  'far fa-window-close',
  'far fa-window-maximize',
  'far fa-window-minimize',
  'far fa-window-restore',
];
